var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isApp)?_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.openUrl()}}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }